import React from 'react';
import { Table, Popover } from 'antd';
import { tableCSS, createEmployeeDataMap, createTableData, createSummaryRows, transformData } from '../utils/commissionUtils';

/**
 * Reusable Commission Table Component
 * @param {Object} props
 * @param {Array} props.employeeData - Employee data array
 * @param {Array} props.optimizeData - Raw commission data (will be transformed)
 * @param {Array} props.dateRange - Optional date range for filling empty dates
 */
const CommissionTable = ({ employeeData, optimizeData, dateRange }) => {
  const employeeDataMap = createEmployeeDataMap(employeeData);
  const transformedData = transformData(optimizeData, employeeData);

  // Merge with date range if provided to ensure all dates are shown
  let finalData = transformedData;
  if (dateRange && Array.isArray(dateRange)) {
    finalData = dateRange.map(date => {
      const existingData = transformedData.find(item => item.date === date);
      return existingData ? existingData : { date, employee: [] };
    });
  }

  const tableData = createTableData(finalData, employeeData, employeeDataMap);
  const { summaryRow, calculatedSummaryRow } = createSummaryRows(tableData, employeeData);

  const columns = [
    {
      title: 'วันที่',
      dataIndex: 'date',
      key: 'date',
      width: '6%',
      align: 'center',
      fixed: 'left'
    },
    {
      title: 'รายชื่อพนักงาน',
      className: 'custom-header',
      children: employeeData?.map((item) => ({
        title: (
          <Popover
            placement="top"
            className='cursor-pointer'
            content={
              <>
                <div>ชื่อ : {item.name}</div>
                <div>ชื่อเล่น : {item.nickname}</div>
                <div>ตำแหน่ง : {item.role}</div>
                <div>ค่าหัต : {item.handfee}</div>
              </>
            }
          >
            ({item.nickname})
          </Popover>
        ),
        children: [
          {
            title: 'ปกติ',
            dataIndex: `${item.name}_regular`,
            key: `${item.name}_regular`,
            align: "center",
            width: "60px"
          },
          {
            title: 'PMS',
            dataIndex: `${item.name}_pms`,
            key: `${item.name}_pms`,
            align: "center",
            width: "60px"
          }
        ]
      })),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={[...tableData, summaryRow, calculatedSummaryRow]}
      rowKey="key"
      size="small"
      className={tableCSS}
      pagination={false}
      scroll={{ x: 'max-content', y: window.innerWidth < 786 ? null : 600 }}
    />
  );
};

export default CommissionTable;
